module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('regular-input', {
    attrs: {
      "value": _vm.input,
      "type": "text",
      "placeholder": _vm.criteria
    },
    on: {
      "input": function($event) {
        _vm.input = $event
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66c7a370","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/module/regularFilter.vue
// module id = 840
// module chunks = 1